module.exports = __webpack_public_path__ + "img/berlinerkranse_glas.39f73c91.jpg";